"use client";
import React, { useEffect, useRef } from "react";
import Parallax from "parallax-js";

export default function WorkProcessOne({
  pillName = "Key Challenges",
  heading = "Bridging the Gap Between Banking and Crypto",
  processSteps = [
    {
      id: 1,
      title: "Compliance & Security",
      description: "Traditional banks face the challenge of integrating crypto services securely and in full compliance with regulations. Impera ensures trusted and risk-managed solutions.",
      icon: "01"
    },
    {
      id: 2,
      title: "Scalable Infrastructure", 
      description: "Crypto businesses require robust platforms capable of handling high transaction volumes and seamless growth. Impera delivers scalable, reliable infrastructure.",
      icon: "02"
    },
    {
      id: 3,
      title: "Unified Customer Experience",
      description: "Efficient onboarding and smooth operations are key to client satisfaction. Impera provides end-to-end workflows for onboarding, trading, and treasury management.",
      icon: "03"
    }
  ],
  imageSrc = "/assets/images/Key Challenges.webp",
  parallaxElements = [
    {
      depth: "0.30",
      content: "Compliance & Security",
      type: "badge",
      color: "bg-[#4A7DFF]"
    },
    {
      depth: "0.40", 
      content: "/assets/images/Etherium.webp",
      type: "image"
    },
    {
      depth: "0.20",
      content: "Unified Customer Experience", 
      type: "badge",
      color: "bg-it-blue"
    }
  ]
}) {
  const sceneRef = useRef(null);

  useEffect(() => {
    if (sceneRef.current) {
      const parallaxInstance = new Parallax(sceneRef.current);
      console.log(parallaxInstance);
      // Cleanup the parallax instance on component unmount
      return () => {
        parallaxInstance.disable();
      };
    }
  }, []);
  return (
    <section id="working-process" className="pt-16 mb-16 md:pb-[153px]">
      <div className="theme-container w-full mx-auto px-4">
        <div className="w-full grid grid-cols-1 lg:grid-cols-12 gap-6 sm:gap-8 lg:gap-12 items-start">
          {/* Image Section - Moved to Left */}
          <div className="lg:col-span-7 order-1 lg:order-1">
            <div className="relative flex justify-center w-full h-full lg:justify-start">
              <div className="h-full">
                <div className="sticky top-[100px] sm:top-[120px] lg:top-[155px]">
                  <div
                    ref={sceneRef}
                    id="home-working-cursor-anim"
                    className="relative"
                  >
                    {parallaxElements.map((element, index) => (
                      <div key={index} data-depth={element.depth} className="z-10 layer h-fit">
                        {element.type === "badge" ? (
                          <span className={`px-4 sm:px-[30px] py-2 sm:py-2.5 ${element.color} shadow-lg shadow-${element.color.split('-')[1]}/25 text-white rounded-full text-xs sm:text-sm md:inline-block hidden`}>
                            {element.content}
                          </span>
                        ) : element.type === "image" ? (
                          <div className="hidden md:inline-block">
                            <img
                              src={element.content}
                              alt=""
                              className="drop-shadow-xl w-8 h-8 sm:w-12 sm:h-12"
                            />
                          </div>
                        ) : null}
                      </div>
                    ))}
                  </div>
                  <div id="progressThumbHeight" className="mt-4 sm:mt-6">
                    <img
                      src={imageSrc}
                      alt=""
                      className="w-full h-auto max-w-sm sm:max-w-md lg:max-w-none mx-auto"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Content Section - Moved to Right */}
          <div className="lg:col-span-5 mb-16 pt-16 order-2 lg:order-2">
            <div className="title-area">
              <h1 className="border text-chip border-purple/30 py-1 px-3 sm:py-0.5 sm:px-5 rounded-[30px] w-fit mb-4 sm:mb-5">
                {pillName}
              </h1>
              <h2 className="mb-6 sm:mb-8 md:mb-[50px] font-semibold text-34 sm:text-34 md:text-48 text-white leading-tight">
                {heading}
              </h2>
              <div
                id="progress-wrapper"
                className="grid grid-cols-1 gap-4 sm:gap-5"
              >
                {processSteps.map((step, index) => (
                  <div
                    key={step.id}
                    data-aos="fade-up"
                    data-aos-delay={index * 100}
                    className="w-full price_card_bg rounded-[16px] sm:rounded-[20px] border border-purple/30 bg-[#160e24] px-4 sm:px-6 md:px-8 py-4 sm:py-6 md:py-8 overflow-hidden group relative transition-all duration-300 hover:border-purple/20"
                  >
                    <div className="relative z-10 flex flex-col space-y-3 sm:space-y-4 md:space-y-5">
                      <div className="flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 bg-[#4A7DFF] border-2 rounded-full border-[#4A7DFF]">
                        <span className="font-semibold text-white text-sm sm:text-base md:text-lg">{step.icon}</span>
                      </div>
                      <div>
                        <p className="mb-3 sm:mb-4 font-semibold text-16 sm:text-18 md:text-20 text-white">
                          {step.title}
                        </p>
                        <p className="text-paragraph text-sm sm:text-base leading-relaxed">
                          {step.description}
                        </p>
                      </div>
                    </div>
                    {/* <div className="absolute top-0 left-0 w-full h-full transition-all duration-300 ease-in-out opacity-0 group-hover:opacity-100">
                      <img
                        src="./assets/images/home-one-ff-item-shape-2.webp"
                        alt=""
                        className="w-full h-full"
                      />
                    </div> */}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
